import { Subscription } from '@innovyze/shared-utils';
import { InnovyzeRole } from '../utils/InnovyzeRole';

export interface License {
	reauthz: number;
	id: string;
	ceid: string;
	o2id: string;
	fid: string;
	exp: number;
	auth: boolean;
	iat: number;
	iss: string;
	lattr: number;
	lattrmsk: number;
}

export interface AutodeskContext {
	oxygenUserId: string;
	companyId: string; // teamId URN from Autodesk
	organizationId: string; // tenantId from Mongo
	projectId?: string;
	currentTeamLicenses: License[];
	otherTeamLicenses: License[];
	role: InnovyzeRole;
	inEmulation?: boolean;
	emulatorOxygenId?: string;
	name?: string;
	email?: string;
	subscriptions?: Record<string, string[]>;
	teamId: string;
	productAccessLevels: string[];
}

export interface Team {
	teamId: string;
	teamName: string;
	tenantId: string;
	projectId?: string;
	hubId?: string;
	projectSourceId?: string;
	entitlements?: Subscription[];
}

export interface AutodeskTeams {
	teams: Team[];
}

export interface AutodeskUserProfile {
	countryCode: string;
	createdDate: string;
	eidmGuid: string;
	emailId: string;
	emailVerified: boolean;
	firstName: string;
	language: string;
	lastLoginDate: string;
	lastModified: string;
	lastName: string;
	optin: boolean;
	profileImages: Record<string, string>;
	userId: string;
	userName: string;
}

/**
 * UserInfo endpoint response (OIDC standard format)
 *
 */
export interface UserInfoResponse {
	sub: string; // Maps to userId
	name?: string; // Full name
	given_name?: string; // Maps to firstName
	family_name?: string; // Maps to lastName
	preferred_username?: string; // Maps to userName
	email: string; // Maps to emailId
	email_verified: boolean; // Maps to emailVerified
	profile?: string; // Profile URL
	picture?: string; // Single profile image URL
	locale?: string;
	updated_at?: number; // Maps to lastModified
	is_twofa_enabled?: boolean;
	country_code?: string; // Maps to countryCode
	address?: {
		street_address?: string;
		locality?: string;
		region?: string;
		postal_code?: string;
		country?: string;
		phone_number_verified?: boolean;
	};
	phones?: unknown[];
	ldap_enabled?: boolean;
	job_title?: string;
	industry?: string;
	industry_code?: string;
	about_me?: string;
	language?: string; // Maps to language
	company?: string;
	created_date?: string; // Maps to createdDate
	last_login_date?: string; // Maps to lastLoginDate
	eidm_guid?: string; // Maps to eidmGuid
	opt_in?: boolean; // Maps to optin
	social_userinfo_list?: unknown[];
	user_thumbnails?: {
		sizeX20?: string;
		sizeX40?: string;
		sizeX50?: string;
		sizeX58?: string;
		sizeX80?: string;
		sizeX120?: string;
		sizeX160?: string;
		sizeX176?: string;
		sizeX240?: string;
		sizeX360?: string;
	}; // Maps to profileImages
	user_source_type?: string;
	alternate_email?: string;
}

export interface ForgeTokenResponse {
	token_type: string;
	expires_in: number;
	id_token: string;
	access_token: string;
	refresh_token: string;
}

export interface ForgeRefreshTokenResponse {
	token_type: string;
	expires_in: number;
	access_token: string;
	refresh_token: string;
}

export interface ForgeRefreshTokenResponseCamel {
	idToken: string;
	accessToken: string;
	refreshToken: string;
	expiresInSeconds: number;
}
